"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isEmptyString = _interopRequireDefault(require("../object/isEmptyString"));

var createMediaFileUrl = function createMediaFileUrl(serverId) {
  if ((0, _isEmptyString["default"])(serverId)) return null;
  return "/api/v1/media/".concat(serverId, "/file");
};

var _default = createMediaFileUrl;
exports["default"] = _default;